import React from 'react';
import { motion } from 'framer-motion';
export function Section3() {
  return <motion.section initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.6
  }} viewport={{
    once: true
  }} className="max-w-3xl mx-auto px-6 py-16" data-id="element-58">
      <h2 className="font-sans font-bold text-3xl text-[#0F4226] mb-8" data-id="element-59">
        3. The Cost of Forgetting — The Damage Chemical Treatments Have Done
      </h2>

      <div className="mb-8" data-id="element-60">
        <img src="https://cdn.magicpatterns.com/uploads/wW7vjm1eTcY6JUbbCPSod7/Dog_resting_in_202604192244_(2).jpg" alt="Pet owner holding their sick dog at the vet" className="w-full rounded shadow-md" data-id="element-61" />
      </div>

      <div className="font-sans text-lg leading-relaxed text-[#666666] space-y-6" data-id="element-62">
        <p data-id="element-63">
          This is the price of the forgetting. The Seresto scandal, the FDA
          neurological warnings, and the Hartz history — framed not as isolated
          scandals but as the predictable consequence of replacing 2,000 years
          of safe plant chemistry with 60 years of synthetic neurotoxins.
        </p>

        <div className="bg-[#C74230]/10 border-l-4 border-[#C74230] p-6 my-8 rounded" data-id="element-64">
          <h3 className="font-sans font-bold text-xl mb-4 text-[#0F4226]" data-id="element-65">
            Seresto
          </h3>
          <p className="mb-2" data-id="element-66">
            75,000 adverse event reports filed with the EPA between 2012 and
            2020.
          </p>
          <p className="mb-2" data-id="element-67">1,698 reported pet deaths.</p>
          <p className="mb-2" data-id="element-68">Congressional investigation launched in 2021.</p>
          <p className="font-semibold text-[#0F4226]" data-id="element-69">
            The collar is still on shelves at PetSmart, Petco, and Walmart
            today.
          </p>
        </div>

        <div className="bg-[#C74230]/10 border-l-4 border-[#C74230] p-6 my-8 rounded" data-id="element-70">
          <h3 className="font-sans font-bold text-xl mb-4 text-[#0F4226]" data-id="element-71">
            FDA Warning (2018)
          </h3>
          <p data-id="element-72">
            The isoxazoline class of oral flea treatments — Nexgard, Bravecto,
            Simparica, Credelio — formally required to add neurological warnings
            including seizures, ataxia, and muscle tremors. Pet owners who had
            reported these symptoms for years were told by vets they were "being
            paranoid."
          </p>
        </div>

        <p data-id="element-73">
          <strong className="text-[#0F4226]" data-id="element-74">Hartz history:</strong> Decades of
          documented pet deaths from organophosphate and pyrethroid toxicity.
          Products still widely sold in mass-market retail.
        </p>

        <p data-id="element-75">
          <strong className="text-[#0F4226]" data-id="element-76">The regulatory failure:</strong>{' '}
          The EPA's pesticide adverse event tracking system was found by
          Congressional investigators to be significantly less rigorous than the
          equivalent system for human drugs. The bar for demonstrating safety
          was lower. The bar for triggering action after safety concerns emerged
          was dramatically higher.
        </p>

        <p className="text-xl font-medium italic border-l-4 border-[#C74230] pl-6 py-4 my-8 bg-[#C74230]/10 text-[#0F4226]" data-id="element-77">
          This is what happens when you replace 2,000 years of plant wisdom with
          60 years of synthetic chemistry and trust a $4 billion industry to
          regulate itself.
        </p>
      </div>
    </motion.section>;
}